import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TabsModule } from 'primeng/tabs';
import { AdminFeasibilityComponent } from './admin-feasibility/admin-feasibility.component';

@Component({
    selector: 'app-freelancer-administration',
    templateUrl: './freelancer-administration.component.html',
    standalone: true,
    imports: [TabsModule, AdminFeasibilityComponent, TranslateModule]
})
export class FreelancerAdministrationComponent {

}
